import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';

type ProtectedRouteProps = {
  redirectPath?: string;
  children?: ReactNode;
  isAllowed: boolean;
};

function ProtectedRoute({
  isAllowed,
  redirectPath = '/',
  children
}: ProtectedRouteProps) {
  if (!isAllowed) {
    // Never forward multiApp to login — boot handoff owns that param.
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
}

export default ProtectedRoute;
